import { BaseModel } from '../base.model';
import { SublocationMaterial } from './SublocationMaterial';

export class SubLocationEntry extends BaseModel {
  subLoc: string;
  subLocMaterial: SublocationMaterial[];
}
